import React from "react";
import Button, { ButtonLevel, ButtonLink } from "components/ui/Button";
import FormContentLayout from "components/layout/FormContentLayout";
import { PartnerSlug } from "types/general";
import { ContentProps } from "./types";

const Subheading = ({ userProfile }: ContentProps) => {
  if (userProfile?.partnerSlug === PartnerSlug.msufcu)
    return (
      <>
        <p>
          We're having trouble identifying income in your MSUFCU checking
          account. Please make sure your direct deposit is being sent to this
          account.
        </p>
        <p>
          If you already connected the account that receives your direct
          deposit, please email us a copy of your most recent pay stub.
        </p>
      </>
    );

  return (
    <>
      We're having trouble identifying income in your checking account. If you
      have direct deposit set up with another checking account, you can try
      connecting that account instead.
    </>
  );
};

const Actions = ({ userProfile, isLoading, openModal }: ContentProps) => {
  if (userProfile?.partnerSlug === PartnerSlug.msufcu)
    return (
      <ButtonLink
        isLoading={isLoading}
        level={ButtonLevel.cta}
        href="mailto:hello@getreset.co?subject=Help verifying income in MSUFCU account&body=I have attached a copy of my most recent paystub."
      >
        Email Us
      </ButtonLink>
    );

  return (
    <Button isLoading={isLoading} onClick={openModal} level={ButtonLevel.cta}>
      Connect Another Checking Account
    </Button>
  );
};

const ActionablePositiveEarningsContent: React.FC<ContentProps> = (props) => (
    <FormContentLayout
      heading="We couldn't find your direct deposit."
      subheading={<Subheading {...props} />}
      actions={<Actions {...props} />}
    />
  );

export default ActionablePositiveEarningsContent;
